export default __webpack_public_path__ + "0209c69e4d17471cb5d35d0b461ebb3d.png";